import { Box, Button, Typography } from '@material-ui/core';
import React from 'react';
import { ResultsLoadError } from './store/types';

const messages: Record<ResultsLoadError, { title: string; detail: string; action: string }> = {
  resultsFailed: {
    title: "We couldn't load your results",
    detail: 'Your simulation finished, but its results did not load. Results for large lineup files can take a few minutes to download.',
    action: 'Load Results',
  },
  statusTimedOut: {
    title: 'Your simulation is taking longer than expected',
    detail: 'It may still be running.',
    action: 'Check Again',
  },
};

interface Props {
  readonly error: ResultsLoadError;
  readonly onRetry: () => void;
}

// Shown in place of the progress bar when a sim's results never reached the screen
const ResultsLoadErrorMessage = ({ error, onRetry }: Props) => {
  const { title, detail, action } = messages[error];
  return (
    <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" width="100%" height="100%" color="white" textAlign="center">
      <Typography variant="h5">{title}</Typography>
      <Box marginTop={1} marginBottom={2} maxWidth={480} style={{ opacity: 0.7 }}>{detail}</Box>
      <Button variant="contained" color="primary" onClick={onRetry}>{action}</Button>
    </Box>
  );
};

export default ResultsLoadErrorMessage;
